import { useQuery } from '@tanstack/react-query';
import { apolloClient } from '@client/api/graphql/client';
import {
  GetPinnedPostsDocument,
  GetPinnedPostsQuery,
  GetPinnedPostsQueryVariables,
  Post,
} from '../../../../generated/graphql';
import { communityQueryKeys } from '../constants';

const getPinnedPosts = async (communityId: number): Promise<Post[]> => {
  const response = await apolloClient.query<
    GetPinnedPostsQuery,
    GetPinnedPostsQueryVariables
  >({
    query: GetPinnedPostsDocument,
    variables: {
      communityId,
    },
    fetchPolicy: 'network-only',
  });
  return (response.data.community?.posts ?? []) as Post[];
};

export const usePinnedPosts = (communityId: number) => {
  return useQuery({
    queryKey: communityQueryKeys.pinnedPosts(communityId),
    queryFn: () => getPinnedPosts(communityId),
    enabled: communityId !== null,
    refetchOnWindowFocus: false,
    refetchInterval: 30000,
  });
};
